import React from 'react';
import HttpRequestHelper from '../Helper/HttpRequestHelper';
import BFFHttpRequestHelper from '../Helper/BFFHttpRequestHelper';
const DefinitionService = {
    getBanks:(body) => {
        return BFFHttpRequestHelper.get("/bank-code",body)
    },
};
export default DefinitionService;